import { InjectionToken } from '@angular/core';

/** True when app is bootstrapped by mobile entrypoint. */
export const APP_SHELL_IS_MOBILE = new InjectionToken<boolean>(
  'APP_SHELL_IS_MOBILE',
);

